import React, { useEffect } from "react";
import { useIntl } from 'react-intl';

// Components;
import { Form } from 'Components';
import Slider from 'Components/Slider';
import { Grid } from '@mui/material';

//own components
import TimeSelector from "Modules/alerts/common/components/TimeSelector"

export const TotalDriveTime = (props) => {

    const { value, onChange, formRef } = props
    const { messages } = useIntl()

    useEffect(() => {
        if (value.drivingHoursExceeded == undefined)
            onChange({
                ...value,
                startWindowTime: 0,
                endWindowTime: 1439,
                drivingHoursExceeded: 8,
            })
    }, [value])

    const getTimeValue = (ojbTime) => {
        
        let timeZone = ojbTime.timeZone
        let hours = timeZone === "AM" ? Number(ojbTime.hours) == 12 ? 0 : Number(ojbTime.hours) : Number(ojbTime.hours) == 12 ? 12 : (Number(ojbTime.hours) + 12)
        let minutes = ojbTime.minutes
        
        let minutesTime = Math.round(Number(hours) * 60 + Number(minutes))
        
        return minutesTime
    }

    const getObjTimeValue = (numberTime) => {
        let objectTime = { hours: '12', minutes: '00', timeZone: 'AM' }
        if (Number.isInteger(numberTime)) {
            let timeZone
            let hours
            let minutes

            let hoursDecimal = numberTime / 60
            hours = Math.trunc(hoursDecimal)
            minutes = Math.round((hoursDecimal - hours) * 60)

            if (numberTime >= 720) {
                timeZone = "PM"
                hours = hours - 12
            } else {
                timeZone = "AM"
            }

            if (hours == 0)
                hours = 12

            if (minutes == 60)
                minutes = 59

            objectTime = {
                timeZone,
                hours: String(hours),
                minutes: String(minutes)
            }
        }

        return objectTime
    }
    
    return (
        <Form ref={formRef}
            onSubmit={() => {
                return (value.startWindowTime < value.endWindowTime)
            }}
        >
            <Grid
                container
                direction="row"
                alignItems="center"
            >
                <div style={{ marginTop: 20 }}>
                    <label className="input-normal-label">{messages['alertsNewAlert_triggersLabel']}</label>
                </div>
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                >
                    {
                        (value.startWindowTime > value.endWindowTime) &&
                        <Grid item sm={12}>
                            <div className="text-danger" style={{ paddingTop: 5 }}>
                                {messages["alertsNewAlert_timeValidation"]}
                            </div>
                        </Grid>
                    }

                    <Grid item sm={6}>
                        <TimeSelector label={messages['alertsNewAlert_startTimeLabel']} value={getObjTimeValue(value.startWindowTime || 0)} onChange={(newValue) => { onChange({ ...value, startWindowTime: getTimeValue(newValue) }) }} />
                    </Grid>
                    <Grid item sm={6}>
                        <TimeSelector label={messages['alertsNewAlert_endTimeLabel']} value={getObjTimeValue(value.endWindowTime || 720)} onChange={(newValue) => {
                            onChange({ ...value, endWindowTime: getTimeValue(newValue) })
                        }} />
                    </Grid>
                </Grid>
                <Grid item sm={12} style={{ marginTop: 20 }}>
                    <label className="input-normal-label">{messages['alertsNewAlert_drivingHoursExceededLabel']}<span className="text-danger"> *</span></label>
                    <Slider
                        min={1}
                        max={24}
                        value={value.drivingHoursExceeded}
                        onChange={(event) => {
                            onChange({ ...value, drivingHoursExceeded: event })
                        }}
                        sliderOneColor={false}
                        showValue
                        valueLabelDisplay={'off'}
                    />
                </Grid>
            </Grid>
        </Form>
    );
}
